// extracted by mini-css-extract-plugin
module.exports = {"main":"TryMedyoucate_main__39PWt","title":"TryMedyoucate_title__L3Y6V","description":"TryMedyoucate_description__2vWT5","button":"TryMedyoucate_button__2I3_H"};